import React, { useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { Row } from "react-bootstrap";
import TemplateCustomization from "./template-customization";
import TemplateDetails from "./template-details";
import {
  resetAddNewTemplate,
  resetNewEmailTemplateContent,
  resetNewEmailTemplateHTMLContent,
  resetNewEmailTemplateTitle,
  resetNewSmsTemplateMessage,
  resetNewSmsTemplateTitle,
  resetNewTemplateType,
} from "../../../redux/actions/new-template";
import { sendErrorNotification } from "../../universal/notifications/notifications";
import { useDispatch, useSelector } from "react-redux";
import { setFallbackMessage } from "../../../redux/actions/universal";
import { ToastContainer } from "react-toastify";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const history = useHistory();

  const addError = useSelector(
    (state) => state.newTemplate.createTemplate.error
  );

  const addStatus = useSelector(
    (state) => state.newTemplate.createTemplate.status
  );

  useEffect(() => {
    if (addStatus && addStatus === "success") {
      dispatch(resetAddNewTemplate());
      dispatch(
        setFallbackMessage({ type: "success", content: "Malen ble opprettet." })
      );
      history.push("/dashboard/maler");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addStatus]);

  useEffect(() => {
    if (addError) {
      sendErrorNotification("Kunne ikke opprette ny liste.");
      dispatch(resetAddNewTemplate());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addError]);

  useEffect(() => {
    dispatch(resetAddNewTemplate());
    dispatch(resetNewEmailTemplateTitle());
    dispatch(resetNewEmailTemplateContent());
    dispatch(resetNewEmailTemplateHTMLContent());
    dispatch(resetNewSmsTemplateTitle());
    dispatch(resetNewSmsTemplateMessage());
  }, []);

  return (
    <section className="dashboard-new-template-section">
      <div className="inner-dashboard-new-template-container">
        <Row className="dashboard-new-template-row">
          <TemplateCustomization />
          <TemplateDetails />
        </Row>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
